import { setRecoil } from "recoil-nexus";
import { userState } from "atoms/userState.atom";

export const updateUserState = (id) => {
  const userArr = { id: id };
  setRecoil(userState, userArr);
};
